"use client";

import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";

import { useStores } from "stores/rootStore";
import { LoginStatus, MeResult } from "stores/userStore";
import { setOrgCookieClient } from "helpers/cookies";
import { useOrgSlug } from "hooks/useOrgSlug";

interface Props {
  children: React.ReactNode;
  user: MeResult | null;
}

const AppInitializer = ({ children, user }: Props) => {
  const orgSlug = useOrgSlug();
  const { userStore, orgStore } = useStores();

  useEffect(() => {
    if (userStore.status === LoginStatus.LoggedIn) {
      return;
    }

    if (user != null) {
      const params = new URLSearchParams(window.location.search);
      const isNew = params.get("isNew") === "true";
      userStore.loggedIn(user, isNew);
      const userOrgs = user.orgs ?? [];
      orgStore.setOrgs(userOrgs);
      const selectedOrg = userOrgs.find(
        (org) => org.slug.toLowerCase() === orgSlug?.toLowerCase(),
      );
      if (selectedOrg != null) {
        orgStore.setSelectedOrg(selectedOrg.id);
        setOrgCookieClient(selectedOrg.slug);
      }
    }
  }, [user, userStore, orgStore, orgSlug]);

  return children;
};

export default observer(AppInitializer);
